import withPage from '@lib/withPage';
import CategoryBreadcrumb from '@src/components/category/CategoryBreadCrumb';
import Reviews from '@src/components/category/Reviews';
import { groupByAlpha } from '@src/components/category/Services';
import WhyBulletPoints from '@src/components/category/WhyBulletPoints';
import Page from '@src/components/page';
import {
	getAllCategories,
	getAllCountries,
	getAllServices,
	getCategoryProps,
	getRoadsideRequest,
	setNavigation,
	setSelectedProvider,
	setVin,
} from '@src/redux/actions';
import { setLocation } from '@src/redux/actions/geolocation';
import * as geoLocationActions from '@src/redux/actions/geolocation';
import dynamic from 'next/dynamic';
import Router from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// Code Splitting of optional renders...
const Collection = dynamic(import('@src/components/productcollection'));
const CollectionTitle = dynamic(import('@src/components/productcollection/common/collection-title'));
const FeaturedCategoryItems = dynamic(import('@src/components/category/FeaturedCategoryItems'));
const LicensePlate = dynamic(import('@src/components/search/LicensePlate'));
const CategoryItems = dynamic(import('@src/components/category/CategoryItems'));

const queryString = require('query-string');
let urlLength;

import CategorySearch from '@src/components/category/CategorySearch';
import LocationRequiredOverlay from '@src/components/category/LocationRequiredOverlay';
import UpdateLocationModal from '@src/components/modals/UpdateLocationModal';
import { fetchCritAndZip } from '@src/utils/geolocation';
import { NextSeo } from 'next-seo';

class Category extends Page {
	constructor(props) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.state = {
			childCategories: [],
			collapse: false,
			isLoadingCategory: true,
			IsLicensePlateOpen: false,
			updatingOptionId: null,
			showAllMakes: true,
			showAddressModal: false,
			showMobileReviews: true,
			showReviews: true,
			masterProvider: null,
			visibleQuickSearchTab: 'initial'
		};

		this.handleOnChange = this.handleOnChange.bind(this);
	}
	static propTypes = {
		isLoadingCategory: PropTypes.bool,
		mainCategory: PropTypes.object,
		childCategories: PropTypes.array,
		featuredCategories: PropTypes.array,
		categoryid: PropTypes.string,
		breadcrumbs: PropTypes.array,
		CurrentIndex: PropTypes.number,
		products: PropTypes.array,
		application: PropTypes.array,
		applicationLabel: PropTypes.string,
		currentLevelQuery: PropTypes.string,
	};

	static async getInitialProps({ res, req, store, query: { categoryid, cityUrl }, ctx }) {
		var updateGeolocation = false;
		var geolocationPayload = null;
		// await store.dispatch(getAllServices());
		if (categoryid == null) {
			if (req) {
				var parsedUrl = queryString.parseUrl(req.url);
				var slug = parsedUrl.url.split('/');

				categoryid = slug[2];
				if (slug.length >= 4) {
					cityUrl = slug[3];
				}

				var { crit, rsrequestid } = parsedUrl.query;
			}
		}

		if (rsrequestid) {
			await store.dispatch(getRoadsideRequest(rsrequestid));
		}

		const initState = store.getState();
		if (initState.countries.countries.length == 0) {
			await store.dispatch(getAllCountries());
		}

		if (cityUrl) {
			const payload = await fetchCritAndZip(cityUrl, false);
			await geoLocationActions.setLocation(payload);
		}

		await store.dispatch(getCategoryProps(categoryid)); // Geolocation will update in Mounting to avoid multi-calls and cookie collision
		return {
			categoryid: categoryid,
			crit: crit,
			cityUrl: cityUrl,
			updateGeolocation: updateGeolocation,
			geolocationPayload: geolocationPayload,
		};
	}

	handleOnChange = item => {
		var path = `/category/${item.urlRedirect != null ? item.urlRedirect : item.urlSlug}`;
		if (this.props.crit) {
			path = `${path}?crit=${this.props.crit}`;
		}
		Router.push(
			`/category/[categoryid]?categoryid=${item.urlRedirect != null ? item.urlRedirect : item.urlSlug}`,
			path
		).then(() => {
			if (window) {
				window.scrollTo(0, 0);
			}
		});
	};

	handleOnSelectionChange = (item, index) => {
		let _this = this;
		this.setState({
			updatingOptionId: index,
		});
		var path = `/category/${item.urlRedirect != null ? item.urlRedirect : item.urlSlug}`;
		if (this.props.crit) {
			path = `${path}?crit=${this.props.crit}`;
		}

		Router.push(
			`/category/[categoryid]?categoryid=${item.urlRedirect != null ? item.urlRedirect : item.urlSlug}`,
			path
		).then(() => {
			if (window) {
				window.scrollTo(0, 0);
			}
			_this.setState({
				updatingOptionId: null,
			});
		});
	};

	toggle() {
		this.setState(state => ({ collapse: !state.collapse }));
	}

	toggleLicensePlate(type) {
		console.log(type, this.state);

		this.setState(state => ({
			visibleQuickSearchTab: type,
		}));
	}

	async componentDidMount() {
		// Get initial window location href
		urlLength = window.location.href.length;
		if (window) {
			window.scrollTo(0, 0);
		}
		const { updateGeolocation, geolocationPayload } = this.props;
		if (updateGeolocation) {
			await this.props.setLocation(geolocationPayload);
			this.setState({ isLoadingCategory: true });
			// FIXME: Causes Side Effects - Need to Figure out  to Allow for GeoLocation to Update Address selection in // Works Correct in Product...
			await this.props.getCategoryProps(this.props.categoryid);
			this.setState({ isLoadingCategory: false });
		}

		this.setState({ isLoadingCategory: false, updateGeolocation: false });
	}

	async componentDidUpdate(prevProps, prevState) {
		if (
			(prevProps.geolocation !== this.props.geolocation &&
				!this.state.isLoadingCategory == true &&
				this.props.geolocation.latitude &&
				(this.props.geolocation.latitude !== prevProps.geolocation.latitude ||
					this.props.geolocation.longitude !== prevProps.geolocation.longitude)) ||
			this.props.priceLevel !== prevProps.priceLevel ||
			(this.props.priceLevel && !prevProps.priceLevel)
		) {
			this.setState({ isLoadingCategory: true });
			await this.props.getCategoryProps(this.props.categoryid);
			this.setState({ isLoadingCategory: false });
		}

		if (prevProps.masterProvider?.name !== this.props.masterProvider?.name) {
			this.setState({ showReviews: !this.props.masterProvider.isActive });
		}
	}

	renderMainArea() {
		const {
			category: { category },
			childCategories,
			categoryid,
			geolocation,
			shop,
			breadcrumbs,
			featuredCategories,
			CurrentIndex,
			products,
			application,
			applicationLabel,
			currentLevelQuery,
		} = this.props;

		const { showReviews } = this.state;

		let fullCategoryName = '';
		this.props.breadcrumbs.forEach((element, index) => {
			if (this.props.breadcrumbs.length <= 3) {
				if (index >= 1) {
					fullCategoryName = fullCategoryName + (index === 2 ? ' for ' : ' ') + element.name;
				}
			} else {
				if (index != 0 && index != 2) {
					fullCategoryName = fullCategoryName + (index === 3 ? ' for ' : ' ') + element.name;
				}
			}
		});

		var imageUrl = null;
		// Parse out Image in any layer to assign to forward section.

	   
		for (var x = 0; x <= breadcrumbs.length; x++) {
			if (x >= 2) {
				for (var z = 0; Array.isArray(childCategories) && z < childCategories.length && childCategories.length > 0 && breadcrumbs[x]; z++) {
					if (childCategories[z] && childCategories[z].length > 0 && breadcrumbs[x] && breadcrumbs[x].id) {
						

						var imageIndex = childCategories[z]?.map(e => e.id).indexOf(parseInt(breadcrumbs[x].id));

						if (imageIndex >= 0) {
							imageUrl = childCategories[z][imageIndex].imageUrl
								? childCategories[z][imageIndex].imageUrl
								: imageUrl;
						}
					}
				}
			}
		}

		var rows = [];
		var SearchName = '';
		var CurrentLevel = applicationLabel + ' ' + currentLevelQuery;

		var ViewAllLabel = childCategories[CurrentIndex]
			? 'View All Items(' + childCategories[CurrentIndex].length + ')'
			: '';

		var IsOpen = this.state.collapse;
		if (featuredCategories[CurrentIndex] && featuredCategories[CurrentIndex].length > 0 ? false : true && !IsOpen) {
			IsOpen = true;
		}

		var showImagesNonFeatured = true;
		if (featuredCategories[CurrentIndex] && featuredCategories[CurrentIndex].length > 0) {
			showImagesNonFeatured = false;
		}

		var SortBy = 'Asc';
		var names = [];
		var sortings = [];
		if (category.showDropDownSearch) {
			if (category.dropDownSearchNames) {
				names = category.dropDownSearchNames.split(',');
				sortings = category.dropDownSearchSortOrder.split(',');

				SearchName = names[CurrentIndex];
				SortBy = sortings[CurrentIndex] ? sortings[CurrentIndex] : 'Asc';
			}
			ViewAllLabel = childCategories[CurrentIndex]
				? 'View All ' + SearchName + 's(' + childCategories[CurrentIndex].length + ')'
				: '';

			const index = breadcrumbs.map(e => e.id).indexOf(category.id.toString());
			for (var i = 0; i < names.length; i++) {
				var currentvalue = (breadcrumbs[index + i + 1] ? breadcrumbs[index + i + 1].id : 0).toString(); // Match Variable type to string
				var loadvalue = (breadcrumbs[index + i] ? breadcrumbs[index + i].id : 0).toString();
			}
		}

		var groupByAlphaFilter = groupByAlpha(childCategories[CurrentIndex], SortBy);
		const showMobileReviews = showReviews && urlLength && urlLength === window.location.href.length;
		const showDescription = showReviews;
		var productslength = products ? products.length ? products.length : 0 : 0 ;
		return (
			<>
				<div className="category-elements-container">
					{productslength > 0 && childCategories[CurrentIndex].length <= 1 ? (
						<Collection
							reviews={this.props.reviews}
							geolocation={geolocation}
							products={products}
							label={applicationLabel}
							applicationSlug={categoryid}
							provider={this.props.provider}
							setSelectedProvider={this.props.setSelectedProvider}
							showBuyButton={true}
							analytics={this.props.analytics}
							locationRequired={this.props.IsLocationRequired}
							isUpdating={this.state.isLoadingCategory}
							imageUrl={imageUrl}
							productServices={this.props.productServices}
							masterProvider={this.props.masterProvider}
							isFeatured={false}
							externalrequest={this.props.roadside}
						/>
					) : (
						// If we don't have products means we're still on the filtering step

						<div className="category-elements internal">
							<div className="container">
								{showMobileReviews && (
									<span className="mobile-disclaimer">
										<span className="text">
											We Come to Your Location and Provide Our Expertise with Stellar Results
										</span>

										<Reviews reviews={this.props.reviews} type="dropdown" />
									</span>
								)}

								<h1>{fullCategoryName}</h1>

								<p className="please-select">
									Please Select your
									<b>
										{category.id
											? category.id == 2 || category.id === 205712
												? CurrentLevel
												: ''
											: ''}
									</b>{' '}
									from Below:
								</p>

								<div className="row">
									<div className={`${showReviews ? 'col-lg-9 main-content' : 'col-lg-12'}`}>
										<div className="group">
											<div className="categories-grid-container">
												{!geolocation.latitude /* && productslength > 0  */ && <LocationRequiredOverlay />}
												<div className={!geolocation.latitude /* && productslength > 0 */  && 'shortened'}>
													<CategorySearch
														updatingOptionId={this.state.updatingOptionId}
														formTitle={`Please Select your ${category.name} Need`}
														type="horizontal"
														dropdownCategories={childCategories}
														application={application}
														names={names}
														onSelectionChange={this.handleOnSelectionChange}
														analytics={this.props.analytics}
														imageUrl={imageUrl}
													/>
													
													{this.renderLicensePlate()}
													{featuredCategories[CurrentIndex] ? (
														<FeaturedCategoryItems
															SearchName={SearchName}
															categoryIndex={CurrentIndex}
															categories={featuredCategories[CurrentIndex]}
															ViewAllLabel={ViewAllLabel}
															clickHandle={this.handleOnChange}
															toggleHandle={() =>
																this.setState({
																	showAllMakes: !this.state.showAllMakes,
																})
															}
															SortBy={SortBy}
															analytics={this.props.analytics}
														/>
													) : (
														''
													)}
													
													<div className={this.state.showAllMakes ? 'visible' : 'hidden'}>
														{childCategories[CurrentIndex] ? (
															<CategoryItems
																IsOpen={IsOpen}
																groupByAlphaFilter={groupByAlphaFilter}
																SearchName={SearchName}
																categoryIndex={CurrentIndex}
																categories={childCategories[CurrentIndex]}
																SortBy={SortBy}
																clickHandle={this.handleOnChange}
																analytics={this.props.analytics}
																showImages={showImagesNonFeatured}
															/>
														) : (
															''
														)}
													</div>
												</div>
											</div>
										</div>

									</div>

									{showReviews && (
										<aside className="col-lg-3">
											<div className="sidebar">
												<Reviews reviews={this.props.reviews} type="vertical" />
											</div>
										</aside>
									)}
								</div>
							</div>
						</div>
					)}
				</div>
			</>
		);
	}

	renderBreadCrumb() {
		const { category, breadcrumbs } = this.props;
		if (!category | !breadcrumbs) return '';
		return <CategoryBreadcrumb category={category} breadcrumbs={breadcrumbs} />;
	}

	renderLicensePlate() {
		const { category, breadcrumbs, products } = this.props;
		const productslength  = products ? products.length  ? products.length :0 :0 ;
		if (!category || productslength > 0) return '';

		if (category.category.id !== 2) return '';
		if (this.props.countries.length == 0) {
			return '';
		}
		return (
			<>
				<div className="model-unknown-disclaimer">
					<div className="text-container">
						<p>
							<span className="text"><i className="far fa-info-circle"></i> {`Quick Search by: `}</span>
							<span className="link" onClick={() => this.toggleLicensePlate('license')}>License Plate</span> or <span className="link" onClick={() => this.toggleLicensePlate('vin')}>VIN Number</span>
						</p>
					</div>
				</div>

				<LicensePlate
					changeVisibility={(value) => this.toggleLicensePlate(value)}
					visibleQuickSearchTab={this.state.visibleQuickSearchTab}
					countries={this.props.countries}
					geolocation={this.props.geolocation}
					setVin={vin => this.props.setVin(vin)}
					analytics={this.props.analytics}
					togglefunction={this.toggleLicensePlate.bind(this)}
				/>
			</>
		);
	}

	render() {
		const { category, childCategories, CurrentIndex, application, applicationLabel, masterProvider, geolocation } =
			this.props;
		const { isLoadingCategory } = this.state;
		
		const productslength  = category.products ? category.products.length  ? category.products.length :0 :0 ;
		if (
			!childCategories[CurrentIndex] ||
			(childCategories[CurrentIndex].length == 0 && productslength == 0)
		) {
			return (
				<div className="page empty-results">
					<UpdateLocationModal
						title="Update Your Location"
						open={this.state.showAddressModal}
						hideModal={() => {
							this.setState({ showAddressModal: false });
						}}
					/>
					<div className="container">
						<div className="info">
							<h6 className="page-title">
								{isLoadingCategory ? (
									<span>
										<i className="fas fa-circle-notch fa-spin mr-2"></i>
										Loading Please Wait...
									</span>
								) : !geolocation.latitude ? (
									'Location is Required to Show Products.'
								) : (
									`Items not Available${
										applicationLabel ? ` for your ${applicationLabel}` : ''
									} and Area Online.`
								)}
							</h6>

							<div className="help">
								<h6>Need help? Here is what you can do</h6>

								<div className="help-elements">
									<a className="help-element" href="tel:+18002288379">
										<i className="fad fa-phone"></i>
										<p>Call help at 1-800-228-8379</p>
									</a>
									<a
										className="help-element"
										href="mailto:info@1800battery.com?Subject=Inquiry%20from%20Website">
										<i className="fad fa-envelope" aria-hidden="true"></i>{' '}
										<p>Get in touch with our support</p>
									</a>

									<button
										className="help-element"
										onClick={() => {
											this.setState({
												showAddressModal: true,
											});
										}}>
										<i className="fad fa-map-marker-alt"></i>
										<p>Change Your Location</p>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}

		var name = '1-800-Battery';
		if (masterProvider && masterProvider.isActive) {
			name = masterProvider.name;
		}
		let hostname = '1800battery.com';
		if (typeof window !== 'undefined') {
			hostname = window.location.hostname;
		}
		const canonical = `https://${hostname}/category/${this.props.categoryid}`;
		// In case crawler somehow reaches duplacate pages, don't index. We recognize those pages because they have ID number instead of id string
		const noindex = !isNaN(this.props.categoryid);
		let fullCategoryName = '';
		this.props.breadcrumbs.forEach((element, index) => {
			if (this.props.breadcrumbs.length <= 3) {
				if (index >= 1) {
					fullCategoryName = fullCategoryName + (index === 2 ? ' for ' : ' ') + element.name;
				}
			} else {
				if (index != 0 && index != 2) {
					fullCategoryName = fullCategoryName + (index === 3 ? ' for ' : ' ') + element.name;
				}
			}
		});

		return (
			<>
				<NextSeo
					title={`${fullCategoryName ? fullCategoryName : 'Get a new batery'}| ${name}`}
					canonical={canonical}
					noindex={noindex}
					// description={category ? category.name && category.description + ' for ' : '' && applicationLabel}
					description={`Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.`}
				/>
				{this.renderBreadCrumb()}

				<div className="page collection">{this.renderMainArea()}</div>

				{(this.props.roadside && this.props.roadside.request) ||
				(this.props.category && this.props.categoryid == 2) ? (
					<div className="container">
						<WhyBulletPoints
							masterProvider={this.props.masterProvider}
							title={
								this.props.roadside && this.props.roadside.request
									? 'Jumpstart Upgrade'
									: 'Why Choose Us'
							}
						/>
					</div>
				) : (
					''
				)}
			</>
		);
	}
}

// const childCategories = getFitmentModelsNoStore(this.props.router.query.categoryid);

const mapStateToProps = state => ({
	geolocation: state.geolocation,
	relatedProducts: state.category.relatedProducts,
	products: state.category.products,
	category: state.category,
	applicationBreadcrumbs: state.category.breadcrumbs,
	application: state.category.application,
	applicationLabel: state.category.applicationLabel,
	breadcrumbs: state.category.breadcrumbs,
	childCategories: state.category.childCategories,
	CurrentIndex: state.category.CurrentIndex,
	featuredCategories: state.category.featuredCategories,
	currentLevelQuery: state.category.currentLevelQuery,
	productServices: state.category.services,
	provider: state.provider,
	countries: state.countries.countries,
	masterProvider: state.masterProvider,
	IsLocationRequired: !(state.geolocation && state.geolocation.formatted_address),
	priceLevel: state.pricelevel.priceLevel,
	roadside: state.roadside,
	reviews: state.reviews,
});

const mapDispatchToProps = {
	getAllCategories,
	getAllServices,
	getCategoryProps,
	setVin,
	setNavigation,
	setSelectedProvider,
	setLocation,
	getRoadsideRequest,
};

export default withPage(connect(mapStateToProps, mapDispatchToProps)(Category));
